module.exports = __webpack_public_path__ + "img/search_img.d5ba5e7b.svg";